import { render } from "./EggPhotoLayer.vue?vue&type=template&id=637e128a"
import script from "./EggPhotoLayer.vue?vue&type=script&lang=js"
export * from "./EggPhotoLayer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__